
// "display": "yes/no", should it be displayed
// "new": "yes/no", should it be treated as a new product
//"sold": "yes/no"

const productData = [
        {
            "name": "Giant Maniax",
            "id": "TB418",
            "meta": [
                {
                    "display": "yes",
                    "new": "yes",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB418.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB418.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/CswuMPSpxlw?si=bcPSiJHDlEG9CsRQ"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "200"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "102"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "25"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "770x390x250"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "350.00"
                }
            ]
        },
        {
            "name": "Connected Cakes 311",
            "id": "TB311",
            "meta": [
                {
                    "display": "yes",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB311.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB311.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/_5mBjnHfI3c"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "224"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "200"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "20/25/30/45"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "770/530/260"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "500.00"
                }
            ]
        },
        {
            "name": "249 shots for Revolution",
            "id": "TB409",
            "meta": [
                {
                    "display": "yes",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB409.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB409.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/SIqve32OIjs?si=CIjqe_NxY4oaCIOa"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "249"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "130"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "20"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "730/270/180"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "250.00",
                }
            ]
        },
        {
            "name": "Storm Bringer",
            "id": "TB400",
            "meta": [
                {
                    "display": "yes",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB400.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB400.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/IVNbSFJ8RWM"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "140"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "90"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "20/30"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "520/380/200"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "250.00"
                }
            ]
        },
        {
            "name": "120 shots for Revolution",
            "id": "TB407",
            "meta": [
                {
                    "display": "yes",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB407.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB407.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/ivSnog6FrAA"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "120"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "109"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "25/30"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "560/320/210"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "220.00"
                }
            ]
        },
        {
            "name": "Apocalypse",
            "id": "TB405",
            "meta": [
                {
                    "display": "yes",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB405.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB405.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/5vSmlCymoKE"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "144"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "95"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "25"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "210/520/390"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "250.00"
                }
            ]
        },
        {
            "name": "Compound Cakes 308",
            "id": "TB308",
            "meta": [
                {
                    "display": "no",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB206-TB308.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB206-TB308.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/Jnss7TadtFU"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "100"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "120"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "30"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "420/410/260"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "200.00"
                }
            ]
        },
        {
            "name": "Compound Cakes 206",
            "id": "TB206",
            "meta": [
                {
                    "display": "no",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB206-TB308.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB206-TB308.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/YxvEXhwoAQU"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "100"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "80"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "30"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "420/410/260"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "200.00"
                }
            ]
        },
        {
            "name": "Connected Cake 307",
            "id": "TB307",
            "meta": [
                {
                    "display": "yes",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB206-TB308.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB206-TB308.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/tjFhrzEA9qI"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "100"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "90"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "25/35"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "275/500/260"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "210.00"
                }
            ]
        },
        {
            "name": "Storm Rider",
            "id": "TB401",
            "meta": [
                {
                    "display": "no",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB407.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB407.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/ukBu7vXfL2k"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "150"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "100"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "25"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "700/270/205"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "190.00"
                }
            ]
        },
        {
            "name": "Space Race 2",
            "id": "TB88",
            "meta": [
                {
                    "display": "yes",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB88.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB88.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/uZH7APmla_c"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "28"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "50"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "45"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "255/380/220"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "120.00"
                }
            ]
        },
        {
            "name": "Estrella",
            "id": "TB417",
            "meta": [
                {
                    "display": "yes",
                    "new": "yes",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB417.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB417.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/IVQ4Zr9-BnE?si=BwD6wL_iMhdkV6qj"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "100"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "90"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "25/30"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "360x250x370"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "220.00"
                }
            ]
        },
        {
            "name": "Patriot",
            "id": "TB191",
            "meta": [
                {
                    "display": "yes",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB191.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB191.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/ArWVBUKMmFs"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "84"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "85"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "25/30"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "225/295/285"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "130.00"
                }
            ]
        },
        {
            "name": "Titan Fire",
            "id": "TB85",
            "meta": [
                {
                    "display": "yes",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB85.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB85.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/8pM9OezM69M"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "120"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "110"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "20"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "345/255/160"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "110.00"
                }
            ]
        },
        {
            "name": "Fire Factory",
            "id": "TB94",
            "meta": [
                {
                    "display": "yes",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB94.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB94.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/XA4Ca4UOyAM"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "25"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "40"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "50"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "310/290/290"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "120.00"
                }
            ]
        },
        {
            "name": "Fire Craft",
            "id": "TB62",
            "meta": [
                {
                    "display": "yes",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB62.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB62.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/PQU8_Mx50LQ"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "57"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "70"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "20/25/30/48"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "275/325/210"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "115.00"
                }
            ]
        },
        {
            "name": "Focus",
            "id": "TB80",
            "meta": [
                {
                    "display": "yes",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB80.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB80.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/j1UaymPEaMM"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "64"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "60"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "30"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "290/290/225"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "110.00"
                }
            ]
        },
        {
            "name": "American",
            "id": "TB300",
            "meta": [
                {
                    "display": "yes",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB300.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB300.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/cpMJdQWMUCM"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "87"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "120"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "25"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "330/270/175"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "105.00"
                }
            ]
        },
        {
            "name": "Big X",
            "id": "TB99",
            "meta": [
                {
                    "display": "yes",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB99.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB99.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/g8NF-xVSOkk"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "44"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "65"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "25/30/38/48"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "275/320/220"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "120.00"
                }
            ]
        },
        {
            "name": "Fire Factory",
            "id": "TB93",
            "meta": [
                {
                    "display": "no",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB93.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB93.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/R1W1OoxpCr8"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "19"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "35"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "46"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "305/290/250"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "95.00"
                }
            ]
        },
        {
            "name": "Space Trip",
            "id": "TB97",
            "meta": [
                {
                    "display": "yes",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB97.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB97.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/9B4aQ8xm8K8"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "49"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "77"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "30"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "225/245/245"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "90.00"
                }
            ]
        },
        {
            "name": "Dragons Tail",
            "id": "TB79",
            "meta": [
                {
                    "display": "yes",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB79.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB79.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/4fNH3XepMzc"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "49"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "59"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "30"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "250/250/225"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "85.00"
                }
            ]
        },
        {
            "name": "Happy New Year",
            "id": "TB78",
            "meta": [
                {
                    "display": "yes",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB78.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB78.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/2IZTGdQNlII"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "49"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "39"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "30"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "250/250/225"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "85.00"
                }
            ]
        },
        {
            "name": "4 Fun",
            "id": "TB119",
            "meta": [
                {
                    "display": "no",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB119.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB119.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/1MddBv4dm7I"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "81"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "82"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "25"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "175/265/265"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "80.00"
                }
            ]
        },
        {
            "name": "Ecstasy",
            "id": "TB65",
            "meta": [
                {
                    "display": "no",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB65.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB65.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/22c0H0Gj0Oo"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "64"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "75"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "25"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "182/242/238"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "70.00"
                }
            ]
        },
        {
            "name": "Fire Craft",
            "id": "TB194",
            "meta": [
                {
                    "display": "no",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB194.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB194.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/T5vfpglz5Qg"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "49"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "50"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "30"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "225/245/245"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "65.00"
                }
            ]
        },
        {
            "name": "Sky Flamenco",
            "id": "TB60",
            "meta": [
                {
                    "display": "no",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB60.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB60.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/NIUxC06LsCA"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "48"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "52"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "30"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "175/325/245"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "65.00"
                }
            ]
        },
        {
            "name": "Night Fever",
            "id": "TW35",
            "meta": [
                {
                    "display": "yes",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TW35.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TW35.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/HTG32a-bNT8"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "48"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "52"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "30"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "175/325/245"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "60.00"
                }
            ]
        },
        {
            "name": "Stairs",
            "id": "TB104",
            "meta": [
                {
                    "display": "yes",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB104.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB104.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/fkiN-RqOcGw"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "61"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "73"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "20/25/30"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "225/320/180"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "65.00"
                }
            ]
        },
        {
            "name": "High Light 1",
            "id": "TW36",
            "meta": [
                {
                    "display": "yes",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TW36.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TW36.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/L2JhJNSAR1c"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "49"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "53"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "25"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "175/210/200"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "60.00"
                }
            ]
        },
        {
            "name": "Orbiter 2",
            "id": "TB181",
            "meta": [
                {
                    "display": "yes",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB181.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB181.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/PqElG3HJapU"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "100"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "52"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "20"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "240/230/120"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "60.00"
                }
            ]
        },
        {
            "name": "Orbiter 1",
            "id": "TB180",
            "meta": [
                {
                    "display": "yes",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB180.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB180.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/YMFUdB7tufw"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "100"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "52"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "20"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "240/230/120"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "60.00"
                }
            ]
        },
        {
            "name": "Red Fox",
            "id": "TB1",
            "meta": [
                {
                    "display": "yes",
                    "new": "yes",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB1.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB1.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/a5B8LG-NjFM?si=WnqfYx93IMKSKUpj"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "80"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "37"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "20"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "150x240x190"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "55.00"
                }
            ]
        },
        {
            "name": "Fighter Air Forces 42",
            "id": "TB56",
            "meta": [
                {
                    "display": "yes",
                    "new": "yes",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB56.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB56.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/sFU_dKb_g1k?si=XyNC5nrnVqfTvYcB"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "42"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "42"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "25"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "170x210x180"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "55.00"
                }
            ]
        },
        {
            "name": "Cassiopeia",
            "id": "TB11",
            "meta": [
                {
                    "display": "no",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB11.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB11.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/TvbxR66fkyo"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "38"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "33"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "30"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "220/205/175"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "55.00"
                }
            ]
        },
        {
            "name": "Space Trip",
            "id": "TB96",
            "meta": [
                {
                    "display": "yes",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB96.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB96.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/FdEP69iaWBw"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "49"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "60"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "25"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "205/205/150"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "55.00"
                }
            ]
        },
        {
            "name": "Viva!",
            "id": "TB86",
            "meta": [
                {
                    "display": "yes",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB86.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB86.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/vZwBsB0HSNg"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "36"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "50"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "25"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "175/190/195"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "55.00"
                }
            ]
        },
        {
            "name": "Storm of Fire",
            "id": "TB58",
            "meta": [
                {
                    "display": "no",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB58.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB58.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/tq4d1qesF8s"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "36"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "26"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "30"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "229/229/229"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "50.00"
                }
            ]
        },
        {
            "name": "Fighter Air Forces",
            "id": "TB52",
            "meta": [
                {
                    "display": "yes",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB52.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB52.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/1k3JfHziBkA?si=ZnAWW3gtY8dNDFHv"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "36"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "60"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "25"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "173/180/180"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "50.00"
                }
            ]
        },
        {
            "name": "Exotic",
            "id": "TB53",
            "meta": [
                {
                    "display": "yes",
                    "new": "yes",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB53.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB53.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/ZsxOuUs6Yqg?si=QuIR4ZNtzgYW2bLX"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "36"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "46"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "30"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "220X215X215"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "60.00"
                }
            ]
        },
        {
            "name": "Exotic",
            "id": "TB37",
            "meta": [
                {
                    "display": "yes",
                    "new": "yes",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB37.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB37.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/nWDWXqsqdAs?si=eG6yLE7jV1swIuZX"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "25"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "39"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "25"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "170x150x150"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "30.00"
                }
            ]
        },
        {
            "name": "Silver Kamuro",
            "id": "TB102",
            "meta": [
                {
                    "display": "no",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB102.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB102.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/-izR_sv9-lg"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "36"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "35"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "30"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "229/229/229"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "50.00"
                }
            ]
        },
        {
            "name": "Starlight Bouquet",
            "id": "TB145",
            "meta": [
                {
                    "display": "no",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB145.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB145.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/-BgHE8eqowc?si=WxhAJu6uBEoKxQPr"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "25"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "29"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "25"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "150/150/175"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "35.00"
                }
            ]
        },
        {
            "name": "Little Star",
            "id": "TB36",
            "meta": [
                {
                    "display": "yes",
                    "new": "yes",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB36.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB36.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/VISJXCXs9H0?si=QN2UWQvU86sZFjdz"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "25"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "32"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "25"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "173x147x150"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "30.00"
                }
            ]
        },
        {
            "name": "Eagle 44",
            "id": "TW44",
            "meta": [
                {
                    "display": "no",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TW44.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TW44.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/sPQKNYUxN7g&t"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "20"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "28"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "25"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "150/120/150"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "30.00"
                }
            ]
        },
        {
            "name": "Space Trip",
            "id": "TB95",
            "meta": [
                {
                    "display": "yes",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB95.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB95.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/_K8hkAsHgVs?si=AW3MW5A00TG1Bznz"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "25"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "40"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "25"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "150/150/150"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "30.00"
                }
            ]
        },
        {
            "name": "4 Stars",
            "id": "TB175",
            "meta": [
                {
                    "display": "yes",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB175.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB175.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/DmcZtieTCkc?si=rdu8sYiMqVM_uwws"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "21"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "21"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "25"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "175/150/150"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "30.00"
                }
            ]
        },
        {
            "name": "Magic Lights",
            "id": "TB26",
            "meta": [
                {
                    "display": "no",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB26.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB26.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/dOBQn-7Bop0t"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "19"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "27"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "25"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "175/150/150"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "20.00"
                }
            ]
        },
        {
            "name": "Exploder 1",
            "id": "TB40",
            "meta": [
                {
                    "display": "no",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB40.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB40.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/SrVbLxZXWqM"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "13"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "20"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "30"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "170/180/100"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "20.00"
                }
            ]
        },
        {
            "name": "Exploder 2",
            "id": "TB41",
            "meta": [
                {
                    "display": "no",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB41.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB41.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/A4l-oPLacQw"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "13"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "20"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "30"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "178/190/102"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "20.00"
                }
            ]
        },
        {
            "name": "Exploder 4",
            "id": "TB43",
            "meta": [
                {
                    "display": "no",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB43.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB43.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/FazsLvFssLc"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "13"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "20"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "30"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "178/190/102"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "20.00"
                }
            ]
        },
        {
            "name": "Eagle 42",
            "id": "TW42",
            "meta": [
                {
                    "display": "yes",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TW42.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TW42.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/jIIyHp4itD4"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "36"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "28"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "20"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "145/145/120"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "25.00"
                }
            ]
        },
        {
            "name": "Eagle 45",
            "id": "TW45",
            "meta": [
                {
                    "display": "no",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TW45.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TW45.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/DHbVLyXaMWA"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "20"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "28"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "25"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "150/120/150"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "20.00"
                }
            ]
        },
        {
            "name": "Silver Night",
            "id": "TB7",
            "meta": [
                {
                    "display": "no",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB7.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB7.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/V7UZ3nReIiI"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "19"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "23"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "26"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "180/175/150"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "17.00"
                }
            ]
        },
        {
            "name": "Exploder 6",
            "id": "TB19",
            "meta": [
                {
                    "display": "no",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB19.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB19.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/ePflZQQn4UU"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "13"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "20"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "30"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "178/190/102"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "16.00"
                }
            ]
        },
        {
            "name": "ZigZag",
            "id": "TB152",
            "meta": [
                {
                    "display": "yes",
                    "new": "yes",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB152.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB152.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/kSeyk-O6Nyk?si=GelWNdRtNIzE8ImV"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "20"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "26"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "20"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "130x120x100"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "15.00"
                }
            ]
        },
        {
            "name": "Piroman",
            "id": "TB148",
            "meta": [
                {
                    "display": "no",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB148.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB148.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/BO3P-t710QM"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "25"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "28"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "20"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "125/115/115"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "15.00"
                }
            ]
        },
        {
            "name": "Piroman Blue",
            "id": "TB147",
            "meta": [
                {
                    "display": "no",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB147.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB147.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/526QQwDzOZE?si=ChrHymiwTUWjbM3v"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "25"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "26"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "20"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "150/120/120"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "15.00"
                }
            ]
        },
        {
            "name": "Piroman",
            "id": "TB146",
            "meta": [
                {
                    "display": "yes",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB146.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB146.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/GqLrusVcJxc"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "16"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "18"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "19"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "96/96/120"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "10.00"
                }
            ]
        },
        {
            "name": "Cassiopeia",
            "id": "TB150",
            "meta": [
                {
                    "display": "no",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB150.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB150.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/QHCzNsDzSE8"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "16"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "23"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "20"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "100/100/120"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "10.00"
                }
            ]
        },
        {
            "name": "Cassiopeia",
            "id": "TB149",
            "meta": [
                {
                    "display": "yes",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB149.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB149.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/zxa9UBm9vgA"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "16"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "23"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "20"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "100/100/120"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "10.00"
                }
            ]
        },
        {
            "name": "Magma",
            "id": "TB154",
            "meta": [
                {
                    "display": "no",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB154.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB154.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/H9N_fmZWPrA?si=JytpI_fWYw4uYvNY"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "16"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "18"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "20"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "95/95/95"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "8.00"
                }
            ]
        },
        {
            "name": "Silver Volcano",
            "id": "TF16",
            "meta": [
                {
                    "display": "yes",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/fountain/png/TF16.png"),
                    "webp": require("../../assets/fireworks/fountain/webp/TF16.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/XvIWMU2cVK8?si=EhQs477a679YXtZ9"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "uguns strūklaka",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "1"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "80"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "20/110"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "330/110"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "20.00"
                }
            ]
        },
        {
            "name": "Gold Volcano",
            "id": "TF17",
            "meta": [
                {
                    "display": "yes",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/fountain/png/TF17.png"),
                    "webp": require("../../assets/fireworks/fountain/webp/TF17.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/xfOxs4yFwqo?si=faomVv6Jb83bsq5p"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "uguns strūklaka",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "1"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "80"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "20/110"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "330/110"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "20.00"
                }
            ]
        },






        {
            "name": "Silver Sparks Volcano",
            "id": "TF10",
            "category": "uguns strūklaka",
            "meta": [
                {
                    "display": "no",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/fountain/png/TF10.png"),
                    "webp": require("../../assets/fireworks/fountain/webp/TF10.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/jiMx-FQHKAk"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "uguns strūklaka",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "1"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "60"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "-"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "278/90"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "12.00"
                }
            ]
        },
        {
            "name": "Silver Fountain",
            "id": "TF9",
            "category": "uguns strūklaka",
            "meta": [
                {
                    "display": "no",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/fountain/png/TF9.png"),
                    "webp": require("../../assets/fireworks/fountain/webp/TF9.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/XmGBiNahvcs"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "uguns strūklaka",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "1"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "30"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "-"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "275/100"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "7.00"
                }
            ]
        },
        {
            "name": "Golden Fountain",
            "id": "TF4",
            "category": "uguns strūklaka",
            "meta": [
                {
                    "display": "no",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/fountain/png/TF4.png"),
                    "webp": require("../../assets/fireworks/fountain/webp/TF4.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/Hqw9peOrdJU"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "uguns strūklaka",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "1"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "35"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "-"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "230/80"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "7.00"
                }
            ]
        },
        {
            "name": "Sparky",
            "id": "TF15",
            "category": "uguns strūklaka",
            "meta": [
                {
                    "display": "no",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/fountain/png/TF15.png"),
                    "webp": require("../../assets/fireworks/fountain/webp/TF15.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/K6s141qiwFg"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "uguns strūklaka",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "3"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "38"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "-"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "560/210/115"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "6.00"
                }
            ]
        },
        {
            "name": "Panda",
            "id": "0819",
            "category": "uguns strūklaka",
            "meta": [
                {
                    "display": "yes",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/fountain/png/0819.png"),
                    "webp": require("../../assets/fireworks/fountain/webp/0819.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/IBI3VokQkaY"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "uguns strūklaka",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "6"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "25"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "-"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "70/40"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "6.00"
                }
            ]
        },
        {
            "name": "Multi Effect (1 gab.)",
            "id": "TRC6",
            "meta": [
                {
                    "display": "no",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/candle/png/TRC6.png"),
                    "webp": require("../../assets/fireworks/candle/webp/TRC6.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/XKCnonWyXl8&t"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "romiešu svece",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "8"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "30"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "29"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "890/37"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "12.00"
                }
            ]
        },
        {
            "name": "One By One (1 gab.)",
            "id": "TRC8",
            "meta": [
                {
                    "display": "no",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/candle/png/TRC8.png"),
                    "webp": require("../../assets/fireworks/candle/webp/TRC8.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/lqBIofw6mf8"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "romiešu svece",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "8"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "30"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "22"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "890/37"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "6.00"
                }
            ]
        },
        {
            "name": "One by One",
            "id": "TRC9",
            "meta": [
                {
                    "display": "no",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/candle/png/TRC9.png"),
                    "webp": require("../../assets/fireworks/candle/webp/TRC9.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/-UmOXrhoeJA?si=05KN2fiO7OnxQu8A"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "romiešu svece",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "8"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "30"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "22"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "780x28"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "6.00"
                }
            ]
        },
        {
            "name": "Gunfire (1 gab.)",
            "id": "TRC1",
            "meta": [
                {
                    "display": "no",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/candle/png/TRC1.png"),
                    "webp": require("../../assets/fireworks/candle/webp/TRC1.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/jrNCs_fpPg0"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "romiešu svece",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "8"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "30"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "20"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "600/28"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "3.00"
                }
            ]
        },
        {
            "name": "Ball Changing Dragon (2 gab.)",
            "id": "0345-20",
            "meta": [
                {
                    "display": "no",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/candle/png/0345-20.png"),
                    "webp": require("../../assets/fireworks/candle/webp/0345-20.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/Jw5LdnU1NkI"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "romiešu svece",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "40"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "30"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "10"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "750/23"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "3.00"
                }
            ]
        },
        {
            "name": "King Rocket",
            "id": "TR08",
            "meta": [
                {
                    "display": "no",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/rocket/png/TR08.png"),
                    "webp": require("../../assets/fireworks/rocket/webp/TR08.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/UbyWTHdekKE"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "raķete",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "3"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "-"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "-"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "970/200"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "40.00"
                }
            ]
        },
        {
            "name": "Air Attack 4",
            "id": "TA51",
            "meta": [
                {
                    "display": "yes",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/rocket/png/TA51.png"),
                    "webp": require("../../assets/fireworks/rocket/webp/TA51.webp"),
                    "video": "-"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "raķete",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "15"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "-"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "-"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "-"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "40.00"
                }
            ]
        },
        {
            "name": "Predator",
            "id": "TR05",
            "meta": [
                {
                    "display": "no",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/rocket/png/TR05.png"),
                    "webp": require("../../assets/fireworks/rocket/webp/TR05.webp"),
                    "video": "-"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "raķete",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "4"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "-"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "-"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "870/110/55"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "30.00"
                }
            ]
        },
        {
            "name": "Wave",
            "id": "TB182",
            "meta": [
                {
                    "display": "yes",
                    "new": "yes",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB182.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB182.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/WQj0rPiLr6o?si=D2gJ2ocoJib-qU-G"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "46"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "42"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "15/20"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "165x120x120"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "25.00"
                }
            ]
        },
        {
            "name": "Magical",
            "id": "TB158",
            "meta": [
                {
                    "display": "yes",
                    "new": "yes",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/battery/png/TB158.png"),
                    "webp": require("../../assets/fireworks/battery/webp/TB158.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/HCMYxCJVMYk?si=UgNGGPFKExgFs2Nr"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "baterija",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "20"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "26"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "25"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "120/150/150"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "25.00"
                }
            ]
        },
        {
            "name": "Starlight",
            "id": "TR06",
            "meta": [
                {
                    "display": "no",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/rocket/png/TR06.png"),
                    "webp": require("../../assets/fireworks/rocket/webp/TR06.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/k2nLXUaNRwU"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "raķete",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "3"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "-"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "-"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "970/200"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "25.00"
                }
            ]
        },
        {
            "name": "Air Attack 2",
            "id": "TA50",
            "meta": [
                {
                    "display": "yes",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/rocket/png/TA50.png"),
                    "webp": require("../../assets/fireworks/rocket/webp/TA50.webp"),
                    "video": "-"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "raķete",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "9"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "-"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "35/25"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "L(5):770/200/S(4):580/120"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "28.00"
                }
            ]
        },
        {
            "name": "Premium Assortment 53",
            "id": "TA53",
            "meta": [
                {
                    "display": "yes",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/rocket/png/TA53.png"),
                    "webp": require("../../assets/fireworks/rocket/webp/TA53.webp"),
                    "video": "-"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "raķete",
                },
                {
                    "name": "Apraksts",
                    "value": "Dažāds skaits un dažāda tipu raķetes, spineri, sprakšķošās granulas un romiešu sveces."
                },
                {
                    "name": "Ilgums (s)",
                    "value": "-"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "-"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "-"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "20.00"
                }
            ]
        },
        {
            "name": "Piroman 33",
            "id": "TA33",
            "meta": [
                {
                    "display": "no",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/rocket/png/TA33.png"),
                    "webp": require("../../assets/fireworks/rocket/webp/TA33.webp"),
                    "video": "-"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "raķete",
                },
                {
                    "name": "Apraksts",
                    "value": "Dažāds skaits un dažādu tipu raķetes, spinneri, sprakšķošās granulas un romiešu sveces."
                },
                {
                    "name": "Ilgums (s)",
                    "value": "-"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "-"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "-"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "8.00"
                }
            ]
        },
        {
            "name": "Whistling Moon Travellers (komplekts)",
            "id": "0445",
            "meta": [
                {
                    "display": "no",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/rocket/png/0445.png"),
                    "webp": require("../../assets/fireworks/rocket/webp/0445.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/Dp04CDmbyhk&t"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "raķete",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "44"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "-"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "-"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "-"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "8.00"
                }
            ]
        },
        {
            "name": "UFO",
            "id": "TR9901",
            "meta": [
                {
                    "display": "yes",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/other/png/TR9901.png"),
                    "webp": require("../../assets/fireworks/other/webp/TR9901.webp"),
                    "video": "https://www.youtube-nocookie.com/embed/CxbXdrDwbzI"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "cits",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "5"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "-"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "-"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "-"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "8.00"
                }
            ]
        },
        {
            "name": "Happy Spinner",
            "id": "TC9",
            "meta": [
                {
                    "display": "yes",
                    "new": "no",
                    "sold": "no"
                }
            ],
            "manufacturer": "Tropic",
            "media": [
                {
                    "img": require("../../assets/fireworks/other/png/TC9.png"),
                    "webp": require("../../assets/fireworks/other/webp/TC9.webp"),
                    "video": "-"
                }
            ],
            "info": [
                {
                    "name": "Kategorija",
                    "value": "cits",
                },
                {
                    "name": "Šāviņu skaits",
                    "value": "12"
                },
                {
                    "name": "Ilgums (s)",
                    "value": "3"
                },
                {
                    "name": "Kalibrs (mm)",
                    "value": "22"
                },
                {
                    "name": "Izmērs (mm)",
                    "value": "245x100x55"
                }
            ],
            "price": [
                {
                    "currency": "EUR",
                    "symbol": "€",
                    "value": "8.00"
                }
            ]
        }
];

// Update the list.
const updates = [ 
'TF16',
'TF17',
'0819',
'TA51',
'TA50',
'TA53',
'TC9',
'TR9901',
'TB104',
'TW35',
'TW36',
'TB180',
'TB181',
'TB53',
'TB86',
'TB1',
'TB56',
'TB96',
'TB52',
'TB36',
'TB37',
'TB175',
'TB95',
'TB182',
'TB158',
'TW42',
'TB152',
'TB149',
'TB146',
'TB311',
'TB418',
'TB400',
'TB409',
'TB405',
'TB407',
'TB417',
'TB307',
'TB191',
'TB88',
'TB99',
'TB94',
'TB62',
'TB85',
'TB80',
'TB300',
'TB97',
'TB79',
'TB78'
 ];

function updateProductDisplay(productData, updates) {
    // Extract IDs from productData for quick lookup
    const productIds = new Set(productData.map(product => product.id));

    // Find IDs in updates that are not present in productData
    const missingIds = updates.filter(id => !productIds.has(id));
    if (missingIds.length > 0) {
        console.log("The following IDs are not present in productData:", missingIds);
    }

    // Update productData
    const updatedProducts = productData.map(product => {
        const shouldDisplay = updates.includes(product.id);
        return {
            ...product,
            meta: product.meta.map(meta => ({
                ...meta,
                display: shouldDisplay ? "yes" : "no"
            }))
        };
    });

    console.log("Product data updated successfully!");
    return updatedProducts;
}

const newProductData = updateProductDisplay(productData, updates);

export default newProductData;